import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "relative z-10",
  "aria-labelledby": "modal-title",
  role: "dialog",
  "aria-modal": "true"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" }, null, -1)
const _hoisted_3 = { class: "fixed z-10 inset-0 overflow-y-auto" }
const _hoisted_4 = { class: "flex items-end sm:items-center justify-center min-h-full p-4 text-center lg:p-0" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h3", { class: "text-lg mb-4 font-bold" }, "Terms and Conditions", -1)
const _hoisted_6 = { class: "p-4 bg-gray-100 text-sm leading-6 text-gray-700 pr-12 rounded" }
const _hoisted_7 = ["href"]
const _hoisted_8 = ["href"]
const _hoisted_9 = { class: "mt-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", {
          class: "relative bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all my-8 max-w-4xl w-full p-6",
          onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
        }, [
          _hoisted_5,
          _createElementVNode("p", _hoisted_6, [
            _createTextVNode(" By clicking \"I Agree\", I confirm that I am an authorized representative of Lender and agree on its behalf that Lender will not solicit or fund any loans to any borrower or person/entity associated with such borrower referred to Lender by Janover Inc. (“Janover”) without first obtaining permission from Janover. Nothing herein supersedes requirements set forth in any associated Agreement. Lender agrees not to share or otherwise use any borrower information received from Janover outside of performing due diligence or otherwise funding a loan, pursuant to an agreement with Janover, and shall maintain any information shared as confidential. Any breach of this confidentiality provision and damages associated with it cannot be calculated. Lender also agrees to Janover’s "),
            _createElementVNode("a", {
              href: _ctx.privacyPolicy,
              class: "text-blue-500",
              target: "_blank"
            }, "Privacy Policy", 8, _hoisted_7),
            _createTextVNode(" and "),
            _createElementVNode("a", {
              href: _ctx.termsAndConditions,
              class: "text-blue-500",
              target: "_blank"
            }, "Terms of Use", 8, _hoisted_8),
            _createTextVNode(" and to receive communications to the contact information shared, including e-mails, SMS/text, autodialed/prerecorded calls for marketing purposes by Janover and its affiliated entities. Consent to such contact is not required for purchase and Lender can opt-out of communications anytime. ")
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("button", {
              type: "button",
              class: "bg-sky text-white text-sm px-4 py-2 rounded-md",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.updateTerms && _ctx.updateTerms(...args)))
            }, "I Agree")
          ])
        ])
      ])
    ])
  ]))
}